import http from "@/http";
// 关联分账
export const routingLink = {
  p: "/api/routing/link",
  r: data => {
    return http({
      url: "/api/routing/link",
      method: "post",
      data
    });
  }
};
//删除分账放
export const delRoutingLink = {
  p: "/api/routing/close",
  r: data => {
    return http({
      url: "/api/routing/close",
      method: "post",
      data
    });
  }
};
//获取接收方列表
export const linkNameList = {
  p: "/api/routing/member",
  r: data => {
    return http({
      url: "/api/routing/member",
      method: "post",
      data
    });
  }
};

//获取分账日志
export const routingLogs = {
  p: "/api/routing/logs",
  r: data => {
    return http({
      url: "/api/routing/logs",
      method: "post",
      data
    });
  }
};

//发起分账
export const routingPush = {
  p: "/api/routing/push",
  r: data => {
    return http({
      url: "/api/routing/push",
      method: "post",
      data
    });
  }
};

//日志详情
export const routingLogInfo = {
  p: "/api/routing/logs_info",
  r: data => {
    return http({
      url: "/api/routing/logs_info",
      method: "post",
      data
    });
  }
};


